module.exports = __webpack_public_path__ + "img/404-error.e33a7144.png";